// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import DialogUser from './DialogUser.jsx';

import {removable, scroll} from './utils.js';

import './css/UserDirs.css';

const root_dir = '/MAPS/';


type T_UserDirsProps = {
  list       : Array<string>,
  forbid_root: boolean,
  dialog_user: DialogUser
};



export default class UserDirs extends Component<T_UserDirsProps> {
  end: Element;
  
  remove: (ev: SyntheticInputEvent<*>) => void;
  
  ref_end: Element;
  
  
  
  constructor(props: T_UserDirsProps) {
    super(props);
    
    this.remove = this.remove.bind(this);
  }
  
  
  
  componentDidUpdate(prevProps: T_UserDirsProps) {
    if (this.props.list.length > prevProps.list.length) {
      scroll(document.getElementById('end_user_dir'));
    }
  }
  
  
  
  remove(ev: SyntheticInputEvent<*>): void {
    this.props.dialog_user.remove_editing_dir(ev.target.dataset.path);
  }
  
  
  
  render() {
    return (
      <div>
        {this.props.list.filter(removable).map((dir, num) => {
          const path = {'data-path': dir};
          
          return (
            <a key={num} className='user_dir' {...path} onClick={this.remove}>
              {dir === root_dir ? 'Todas' : _.initial(dir.slice(6).split('/')).join(' / ')}
            </a>
          );
        })}
        
        <div id='end_user_dir' />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/UserDirs.jsx